import { ForwardedRef, forwardRef, PropsWithChildren, Ref, useMemo } from 'react';

import { chipGroupContext, ChipGroupContext } from '../ChipGroupItem/ChipGroupItem.types';

import styles from './InclusiveChipGroup.module.scss';
import { InclusiveChipGroupProps } from './InclusiveChipGroup.types';

const InclusiveChipGroupInner = <T extends string>(
  {
    size = 'medium',
    value,
    children,
    onValueChange,
    disabled,
    error,
  }: PropsWithChildren<InclusiveChipGroupProps<T>>,
  ref: ForwardedRef<HTMLDivElement>
) => {
  const chipGroup = useMemo(
    (): ChipGroupContext => ({
      size,
      selectedValues: value ?? [],
      // @ts-expect-error we can treat clickedValue as T
      onSelectValue: (clickedValue: T) => {
        if (value?.includes(clickedValue))
          onValueChange?.(value.filter(item => item !== clickedValue));
        else onValueChange?.((value ?? [])?.concat([clickedValue]));
      },
      disabled,
      error,
    }),
    [disabled, error, onValueChange, size, value]
  );

  return (
    <chipGroupContext.Provider value={chipGroup}>
      <div className={styles.inclusiveChipGroup} ref={ref}>
        {children}
      </div>
    </chipGroupContext.Provider>
  );
};

export const InclusiveChipGroup = forwardRef(InclusiveChipGroupInner) as <T extends string>(
  props: PropsWithChildren<InclusiveChipGroupProps<T>> & { ref?: Ref<HTMLDivElement> }
) => ReturnType<typeof InclusiveChipGroupInner>;
